/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

function getSubscriptionBilling(subscriptionPlan) {
  let billingCycle;
  switch (subscriptionPlan) {
    case 1:
      billingCycle = 'Monthly';
      break;
    case 12:
      billingCycle = 'Annual';
      break;
    default:
  }
  return billingCycle;
}

function getSubscriptionBillingData(data) {
  const billingData = {
    'Billing Cycle': getSubscriptionBilling(data.subscription_plan),
    'Payment Amount': data.total_amount,
    'Total Outlet': data.purchased_outlets.length,
  };
  return billingData;
}

export function accountSettingsOpenBilling(data) {
  const billingData = getSubscriptionBillingData(data);
  pushClevertapEvent('Setting Billing Start', billingData);
}

export function accountSettingsBillingPay(data) {
  const billingData = getSubscriptionBillingData(data);
  pushClevertapEvent('Billing Payment Redirect to Midtrans', billingData);
}

export function billingRedirectClevertap(success, data) {
  const eventName = success
    ? 'Setting Billing Payment Successful'
    : 'Setting Billing Payment Failed';
  pushClevertapEvent(eventName, {
    'Order ID': data.orderId,
  });
}
